module.exports = "<h1 id=\"vbl\">vbl</h1>\n<h2 id=\"-\">介绍</h2>\n<p>简单可复用的后台ui解决方案</p>\n<ul>\n<li>根据ui设计专门定制</li>\n<li>使用从后台需求中提取</li>\n<li>基于vue 2</li>\n<li>统一的前端规范</li>\n</ul>\n<h2 id=\"-\">使用</h2>\n<h3 id=\"-\">安装</h3>\n<pre><code>npm install vue-vbl\n</code></pre><h3 id=\"-\">引入</h3>\n<pre><code>import Vue from &#39;vue&#39;;\nimport VueVbl from &#39;vue-vbl&#39;;\nimport &#39;vue-vbl/dist/vue-vbl.css&#39;;\n\nVue.use(VueVbl);\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./README.md
// module id = 132
// module chunks = 0